import { render, staticRenderFns } from "./CompanySwitcher.vue?vue&type=template&id=f7cda5e0&scoped=true&"
import script from "./CompanySwitcher.vue?vue&type=script&lang=js&"
export * from "./CompanySwitcher.vue?vue&type=script&lang=js&"
import style0 from "./CompanySwitcher.vue?vue&type=style&index=0&id=f7cda5e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cda5e0",
  null
  
)

export default component.exports